import React, { useState } from 'react';
import axios from 'axios';
import './RecuperarPassword.css';
import fondo from '../assets//img_generales/fondo.png';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config';


const RecuperarPassword = () => {
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [correo, setCorreo] = useState('');
  const navigate = useNavigate();

  const recuperar = async () => {
    if (!nombreUsuario || !correo) {
      alert('Por favor completa ambos campos.');
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/recuperar-password`, {
        nombreUsuario,
        correo
      });

      if (response.data.ok) {
        alert(`Tu contraseña es: ${response.data.password}`);
      } else {
        alert(response.data.mensaje || 'Usuario no encontrado.');
      }
    } catch (error) {
      console.error('❌ Error al recuperar contraseña:', error);
      alert('Error al intentar recuperar la contraseña. Intenta nuevamente.');
    }
  };

  return (
    <div className="pantalla-registro" style={{ backgroundImage: `url(${fondo})` }}>
      <div className="contenedor-registro">
        <h2 style={{ textAlign: 'center' }}>Recuperar Contraseña</h2>
        <input
          name="nombreUsuario"
          placeholder="Nombre de Usuario"
          value={nombreUsuario}
          onChange={(e) => setNombreUsuario(e.target.value)}
          className="input-registro"
        />
        <input
          name="correo"
          placeholder="Correo Electrónico"
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
          className="input-registro"
        />
        <button onClick={recuperar} className="boton-registro">Recuperar</button>
        <button onClick={() => navigate('/pantalla-inicio')} className="boton-volver">Volver</button>
      </div>
    </div>
  );
};

export default RecuperarPassword;
